import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { DashboardNavigatorPicker } from "./DashboardNavigatorPicker";
import "./DashboardNavigator.css";

export function DashboardNavigator({
  open,
  currentScreen,
  onClose,
  onNavigate,
}) {
  useEffect(() => {
    if (!open) {
      return undefined;
    }

    function handleKeyDown(e) {
      if (e.key === "Escape") {
        onClose();
      }
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose]);

  const handleSelect = (screenId) => {
    if (screenId === currentScreen) {
      onClose();
      return;
    }
    onNavigate(screenId);
  };

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            className="dashboard-navigator-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={onClose}
            aria-hidden="true"
          />
          <motion.div
            className="dashboard-navigator-sheet"
            role="dialog"
            aria-modal="true"
            aria-label="Dashboard Navigator"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 24 }}
            transition={{ type: "spring", damping: 28, stiffness: 320 }}
          >
            <DashboardNavigatorPicker
              currentScreen={currentScreen}
              onSelect={handleSelect}
            />
            <p className="dashboard-navigator-footer">
              Scroll to browse · Tap to open
            </p>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
